<template>
  <div>
    <div style="padding:5px 5px 5px 5px">
      <div id="hello-hello">
        <p style="display:inline;float: left;line-height: 22px;"><b>-生产周期记录</b></p>

        <p style="display:inline;float: right;line-height: 40px;margin:5px 0">
          <el-button round @click="batchDownload">下载</el-button>
          <span>-</span>
        </p>

      </div>
    </div>

    <el-table :data="fileList" style="width: 100%" highlight-current-row @selection-change="handleSelectionChange">
      <el-table-column type="selection" width="45">
      </el-table-column>

      <el-table-column label="文件名" min-width="10%">
        <template #default="scope">
          <el-tag type="primary" @click="download(scope.row)">{{ scope.row }}</el-tag>
        </template>
      </el-table-column>

    </el-table>

  </div>
</template>

<script>
import router from '../../router';

export default {
  name: "ProductInfoRecord",
  data() {
    return {
      token: this.getToken(),
      userId: this.getUserId(),
      companyId: this.getCompanyId(),

      fileList: [],

      multipleSelection: []
    }
  },
  methods: {
    handleSelectionChange(val) {

      this.multipleSelection = val
    },
    batchDownload() {
      var rows = this.multipleSelection

      if (rows) {

        rows.forEach(row => {
          
          this.download(row)
        })

      }

    },
    download(val) {

      this.$axios({
        method: "post",
        url: "/shiro/product/kanban/download",
        data: {
          productName: val,
          companyId: this.companyId
        },
        headers: {
          token: this.token
        },
        responseType: 'arraybuffer'
      }).then(result => {

        const data = result.data

        let objectUrl = result.config.url
        const blob = new Blob([data], {
          type: 'application/vnd.ms-excel;charset=utf-8'
        })

        objectUrl = URL.createObjectURL(blob)
        const a = document.createElement("a")
        a.href = objectUrl

        a.download = val

        a.click()
        a.remove()
        URL.revokeObjectURL(objectUrl)
      })
    },
    getAll() {

      this.$axios({
        method: "post",
        url: "/shiro/product/kanban/report",
        data: {
          companyId: this.companyId
        }, headers: {
          token: this.token
        }
      }).then(result => {

        const data = result.data

        // console.log(data)

        this.fileList = data.data
      })
    }

  },
  mounted() {
    this.setDefaultPath('/productInfoRecord')

    this.getAll()
  }
}
</script>

<style>
#create_company {
  position: relative;
  right: 5px;
  width: 120px;
}

#cancel_determine {
  position: absolute;
  bottom: 5px;
  right: 5px;
}
</style>